import axios from '../utils/axios';

export default function fetchApplicationCount(adminId, jobId, params) {
    return (
        axios.get('/admin/' + adminId + '/job/' + jobId + '/applications/count', { params })
    )
}
